export default __webpack_public_path__ + "static/media/bg_third.7bf42775.png";